import moment from "moment";
import { formatDatamartFilters } from "utils/formatV2DatamartFilters";
import { useFetch } from "./api";
import { useMemo } from "react";

const useHaloRank = (marketPlace, options = {}) => {
  const now = moment();
  const now30 = moment().subtract(30, "days");
  const filters = formatDatamartFilters({
    //marketplace: marketPlace.marketPlace,
    date__gte: now30.format("YYYY-MM-DD"),
    date__lte: now.format("YYYY-MM-DD"),
  });

  const { data, isLoading } = useFetch(
    ["halo", marketPlace.marketPlace],
    "/api/data_report_v2/shopperinsights/stats/",
    {
      dimensions: "product_id",
      filters,
      limit: 100,
      sort: "-halo_sales",
    },
    {
      select: (res) => res.data,
      default: [],
      ...options,
    },
  );

  const ranks = useMemo(() => {
    const sortedData = data?.filter((d) => d.halo_sales > 0)?.sort((a, b) => b.halo_sales - a.halo_sales) ?? [];
    const ranks = sortedData.reduce((acc, d, i) => {
      acc[d.product_id] = i + 1;
      return acc;
    }, {});
    return ranks;
  }, [data]);

  return { ranks, isLoading };
};

export default useHaloRank;
